import React, { Component } from 'react'
import {
  CellMeasurer,
} from 'react-virtualized'

import styles from './styles.scss'

const Cell = (props) => {
  const {
    children,
    getCache,
    columnIndex,
    parent,
    rowIndex,
    key,
    style,
    onClick
  } = props

  return (
    <CellMeasurer
      cache={getCache()}
      columnIndex={columnIndex}
      key={key}
      parent={parent}
      rowIndex={rowIndex}
    >
      <div onClick={onClick} class={styles.cell} style={style}>
        { children }
      </div>
    </CellMeasurer>
  )
}

export default Cell
